import moment from 'moment';

import { DATE_FORMAT } from 'common/constants/dateConstants';

/* eslint-disable import/prefer-default-export, react/jsx-filename-extension */
export const bottomTicksFormatter = date => moment(date).format(DATE_FORMAT);
